var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.time === 0 || _vm.time === 1)?_c('span',[_vm._v("sofort versandfertig")]):(_vm.time > 1 && _vm.time <= 14)?_c('span',[_vm._v("in "+_vm._s(_vm.time)+" Tagen versandfertig")]):_c('span',[_vm._v("am "+_vm._s(_vm.getDeliveryReadyDateString(_vm.time))+" versandfertig")])
}
var staticRenderFns = []

export { render, staticRenderFns }